import React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../lib/utils';

/**
 * Der Kartenstil, den die Seiten bisher jeweils selbst ausgeschrieben haben
 * ("bg-white rounded-xl shadow-sm border border-slate-200 p-6"). Hier einmal
 * benannt, damit Abstände und Rahmen nicht auseinanderlaufen.
 */
const cardVariants = cva(
  'rounded-xl border bg-white transition',
  {
    variants: {
      tone: {
        default: 'border-slate-200 shadow-sm',
        muted: 'border-slate-200 bg-slate-50 shadow-none',
        danger: 'border-red-200 bg-red-50 shadow-none',
        dashed: 'border-2 border-dashed border-slate-200 shadow-none',
      },
      padding: {
        none: 'p-0',
        sm: 'p-4',
        md: 'p-6',
        lg: 'p-8',
      },
      interactive: {
        true: 'hover:border-brand-300 hover:shadow-md',
        false: '',
      },
      // Nach "tone" deklariert, damit cn() den Schatten zuverlaessig aufhebt.
      flat: {
        true: 'shadow-none',
        false: '',
      },
    },
    defaultVariants: { tone: 'default', padding: 'md', interactive: false, flat: false },
  },
);

export interface CardProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof cardVariants> {
  /** Rendert stattdessen das Kindelement - etwa einen Link, der wie eine Karte aussieht. */
  asChild?: boolean;
}

export const Card: React.FC<CardProps> = ({
  className, tone, padding, interactive, flat, asChild = false, ...props
}) => {
  const Comp = asChild ? Slot : 'div';
  return <Comp className={cn(cardVariants({ tone, padding, interactive, flat }), className)} {...props} />;
};
